import { supabase } from '../lib/supabase';
import { useEffect, useState } from 'react';
import type { Customer } from '../types/domain';

export default function CustomersPage() {
  const [customers, setCustomers] = useState<Customer[]>([]);

  useEffect(() => {
    supabase.from('customers').select('*').limit(50).then(({ data }) => {
      if (data) setCustomers(data);
    });
  }, []);

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 32 }}>
      <h1 style={{ marginBottom: 24 }}>Clientes</h1>
      {customers.length === 0 && <p style={{ color: 'var(--color-text-muted)' }}>Nenhum cliente cadastrado.</p>}
      {customers.map((c) => (
        <div key={c.id} style={{ padding: 12, background: 'var(--color-surface)', borderRadius: 'var(--radius)', marginBottom: 8, border: '1px solid var(--color-border)' }}>
          <strong>{c.name}</strong> — {c.phone}
        </div>
      ))}
    </div>
  );
}